import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ConfigService } from 'src/app/core/service/config.service';
import { ListModal } from 'src/app/features/multi-auction-bidder/core/modal/list-modal';
import { MultiAuctionService } from 'src/app/features/multi-auction-bidder/core/service/multi-auction.service';
import { AuctionList } from '../../../auction-listing/interface/auction-list';
import { OpenCreateItemDialog } from 'src/app/shared/Functions/auction';
import { MatDialog } from '@angular/material/dialog';
import { CdkDrag, CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { socketActions } from 'src/app/features/rooms/core/enums/socketActions';
import { SocketUpates } from 'src/app/features/rooms/core/modal/socketUpdates';
import { SocketService } from 'src/app/features/bidders/core/service/socket.service';
import { Subscription } from 'rxjs';
import { HardRedirectComponent } from '../../../hard-redirect/hard-redirect.component';

@Component({
  selector: 'app-list-items-auction',
  templateUrl: './list-items-auction.component.html',
  styleUrls: []
})
export class ListItemsAuctionComponent implements OnInit {
  @Input() roomDetails: any;
  @Input() activeAuctionWork: any;
  @Input() CurrentItemIsPublished!: 0 | 1;
  @Input() closedAuctionSocket: any;
  @Input() reloadList!: number;
  @Input() DeletedItem!: string;

  @Output() getItemsActive = new EventEmitter<any>();
  @Output() listingItems = new EventEmitter<any>();
  @Output() atLeastOnePublished = new EventEmitter<boolean>();

  userInfo: any;
  listing: ListModal[] = [];
  AuctionListFilter: AuctionList = {
    is_active: 1,
    search: "",
    sortBy: "order",
    sort: "ASC",
    start_date: "",
    end_date: "",
    room_id: "",
    page: 1,
    perPage: 10
  }
  disAllowSort: boolean = true;
  CurrentItemId!: string
  loading: boolean = false;
  loadingData: boolean = false;
  loadMoreData: boolean = false;
  subscriptions: Subscription[] = [];
  pageCount: number = 0;

  constructor(public _api: MultiAuctionService,
    public _config: ConfigService,
    private dialog: MatDialog,
    public socket: SocketService
  ) {
    this.userInfo = _config.getAuthUserInfo();
  }

  ngOnInit() {
    this.AuctionListFilter.room_id = this.roomDetails?.id;
    console.log(this.roomDetails);

    this.onGetListing(true);
    this.subscriptions.push(
      this.socket.getDataStream<string>(`room-or-auction-updated`)
        .subscribe(message => {
          let data: SocketUpates = message.data;
          if (data.roomId == this.roomDetails?.id && data.auctionId && !data.isChangeOnRoom &&
            this._config.getAuthUserInfo().user?.role_code == "General" &&
            (data.typeChanges != socketActions.LEAVED && data.typeChanges != socketActions.JOINED)) {
            this.OpenConfirmRedirect();
          }
          if (data.roomId == this.roomDetails?.id && data.auctionId && !data.isChangeOnRoom &&
            this._config.getAuthUserInfo().user?.role_code == "Admin" &&
            data.typeChanges == socketActions.DELETED) {
            this.loadingData = true;
            this.onGetListing(true);
          }
          if (data.roomId == this.roomDetails?.id && data.auctionId && data.isChangeOnRoom &&
            this._config.getAuthUserInfo().user?.role_code == "General" &&
            data.typeChanges == socketActions.IMPORTED) {
            this.OpenConfirmRedirect();
          }
        }))
  }

  ngOnChanges(changes: any): void {
    if ('activeAuctionWork' in changes) {
      if (changes.activeAuctionWork.previousValue) {
        this.roomDetails.type = 'ongoing';
        this.getItems(this.activeAuctionWork)
        this.listing = this.ColseItemsEnded(this.listing, this.activeAuctionWork)
      }
    }
    if ('closedAuctionSocket' in changes) {
      if (changes.closedAuctionSocket.previousValue) {
        const obj = this.listing?.find(x => x.id == changes.closedAuctionSocket.previousValue);
        obj!.is_closed = 1;
      }
    }

    if ('DeletedItem' in changes) {
      const index = this.listing.findIndex((element) => element.id == this.DeletedItem);
      if (index > -1) { // only splice array when item is found
        this.listing.splice(index, 1); // 2nd parameter means remove one item only
        this.CurrentItemId = this.listing[index].id;
        this.getItems(this.CurrentItemId)
      }
    }

    if ('CurrentItemIsPublished' in changes && this.listing.length) {
      this.listing.forEach(element => {
        if (element.id == this.CurrentItemId) {
          element.is_published = changes.CurrentItemIsPublished?.currentValue
        }
      });
      let havePublishedItems = this.listing.some(element => element.is_published == 1)

      if (havePublishedItems) {
        this.atLeastOnePublished.emit(true)
      } else {
        this.atLeastOnePublished.emit(false)
      }
    }

    if ('reloadList' in changes) {
      console.log("reloadList Changes", changes.reloadList);
      if (changes.reloadList.currentValue) {
        this.loadingData = true;
        this.onGetListing(true);
      }
    }


  }
  onGetListing(firstTime?: boolean) {
    if (this._config.getAuthUserInfo()?.user?.role_code == "General" || !this._config.getAuthUserInfo()) {
      this._api.getListing(this.roomDetails.id).subscribe({
        next: (data) => {
          // debugger
          if (firstTime) {
            this.listing = data.data;
          } else {
            this.listing = this.listing.concat(data.data);
          }


          this.pageCount = Math.ceil(
            data.data.total / this.AuctionListFilter.perPage
          );
          this.loadingData = false;
          this.loadMoreData = false;
          if (!this.roomDetails.is_me_joined || this.roomDetails.is_closed) {

            if (this.listing.length) {
              this.activeAuctionWork = this.listing[0].id;
            } else {
              this.activeAuctionWork = null;
            }

          } else {
            const obj = this.listing?.find(x => !x.is_closed)
            this.activeAuctionWork = obj!.id;
          }
          this.listingItems.emit(this.listing)
          this.getItems(this.activeAuctionWork)
          if (this.roomDetails.type != 'upcoming' && this.roomDetails?.is_me_joined) {
            this.listing = this.ColseItemsEnded(this.listing, this.activeAuctionWork)
          }

        }, error: (err) => {
          this.loadingData = false;

          if (err.errors[0].field == "itemNotFound") {
          }
        }
      })
    } else {
      this._api.getListingForAdmin(this.AuctionListFilter).subscribe({
        next: (response) => {

          // this.listing = this.listing.concat(response.data.list);
          if (firstTime) {
            this.listing = response.data.list;
          } else {
            this.listing = this.listing.concat(response.data.list);
          }

          this.pageCount = Math.ceil(
            response.data.total / this.AuctionListFilter.perPage
          );
          this.loadingData = false;
          this.loadMoreData = false;

          if (this.listing.length && this.roomDetails.type != 'ongoing') {
            this.activeAuctionWork = this.listing[0]?.id;
          }
          this.getItems(this.activeAuctionWork);
          this.listingItems.emit(this.listing);
          this.listing = this.ColseItemsEnded(this.listing, this.activeAuctionWork)


        }, error: (err) => {
          this.loadingData = false;
          if (err.errors[0].field == "itemNotFound") {
          }
        }
      })
    }

  }

  getItems(id: string) {
    const obj = this.listing?.find(x => x.id == id);
    this.getItemsActive.emit(obj);
    this.CurrentItemId = id;
  }


  onCreateAuction() {
    OpenCreateItemDialog(this.roomDetails, this.dialog);
    // this._auctionService.getLoadListValue().subscribe((res) => {
    //   if (res) {
    //     this.getRoomDetail()
    //   }
    // })
  }

  drop(event: CdkDragDrop<any>) {
    moveItemInArray(this.listing, event.previousIndex, event.currentIndex);
  }


  OnClickSort() {
    if (this.disAllowSort) {
      this.disAllowSort = false;

    } else {
      // Call api to apply sort in back-end
      let SortedIds = this.listing.map((item, index) => { return { auction_id: item.id, order: index + 1 } })
      // debugger
      let modal = {
        items: SortedIds,
        room_id: this.roomDetails?.id
      };
      this.loading = true;
      this._api.SortItems(modal).subscribe({
        next: (result) => {
          this.loading = false;
          this._config.toastrService.success(result.message)
          this.disAllowSort = true;
        },
        error: (error) => {
          this.loading = false;
          this._config.showErrors(error);
        }
      })
    }
  }

  OpenConfirmRedirect() {
    let title, lable: string = ''


    title = "multiAuction.Update your auction information"
    lable = "multiAuction.Items list has been updated form administrator press Confirm to continue"

    this.dialog.closeAll();
    const dialogRef = this.dialog.open(HardRedirectComponent, {
      width: '550px',
      data: { title, lable },
      panelClass: 'customDialogStyle',
      disableClose: true
    });

    dialogRef.afterClosed().subscribe((res: any) => {
      if (res) {
        this.loadingData = true;
        this.onGetListing(true);
      }
    })


  }

  getNextPage() {
    if (this.AuctionListFilter.page <= this.pageCount - 1) {
      this.AuctionListFilter.page += 1;
      this.loadMoreData = true;
      this.onGetListing();
    }

  }

  ColseItemsEnded(ListItems: any[], activeAuctionWork: string) {
    if (this._config.getAuthUserInfo()) {
      const ActiveIndex = ListItems.findIndex((item) => item.id == activeAuctionWork)
      if (this.roomDetails?.type == 'upcoming') {
        for (let index = 0; index < ListItems.length; index++) {
          ListItems[index].is_closed = false;
          ListItems[index].type = 'upcoming';
        }
      } else if (this.roomDetails?.type == 'ongoing') {
        for (let index = 0; index < ListItems.length; index++) {
          if (ListItems[index].id != activeAuctionWork && ActiveIndex > index) {
            ListItems[index].is_closed = true;
            ListItems[index].type = 'completed';
          }
          else if (ListItems[index].id != activeAuctionWork && ActiveIndex < index) {
            ListItems[index].is_closed = false;
            ListItems[index].type = 'upcoming';
          }
          else if (ListItems[index].id == activeAuctionWork && ActiveIndex == index) {
            ListItems[index].is_closed = false;
            ListItems[index].type = 'ongoing';
          }
        }
      } else if (this.roomDetails?.type == 'completed') {
        for (let index = 0; index < ListItems.length; index++) {
          ListItems[index].is_closed = true;
          ListItems[index].type = 'completed';
        }
      }

      this.getItems(activeAuctionWork)
      this.listingItems.emit(ListItems);
    }
    return ListItems
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }
}
